import { CushionedBox } from '~/components/Layout/CushionedBox';

export function EmptySharedDesignList() {
    return (
        <CushionedBox>
            <p>No designs have been shared with you yet.</p>
        </CushionedBox>
    );
}
